import { app } from '@lib';

function getFileType(file) {
  let fileType;
  const { type } = file;
  if (type.indexOf('image') === 0) {
    fileType = '1';
  } else if (type.indexOf('video') === 0) {
    fileType = '3';
  } else if (type.indexOf('audio') === 0) {
    fileType = '4';
  } else {
    fileType = '2';
  }

  return fileType;
}

export default {
  // 获取通知
  getNotice() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/notice/getNotice',
    });
  },
  // 获取即将过期通知
  getExpireNotice() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/notice/getExpireNotice',
    });
  },
  // 关闭即将过期通知
  closeExpireNotice(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/notice/closeExpireNotice',
      params,
    });
  },
  // 查询最新首页提醒
  getHomeNotice() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/notice/get',
    });
  },
  // 推送按钮点击统计
  noticeClick(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/notice/click',
      params,
    });
  },
  // 创建员工
  createTeacher(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/create',
      params,
    });
  },

  // 编辑员工
  editTeacher(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/editTeacher',
      params,
    });
  },

  // 删除员工
  deleteTeacher(params) {
    return app.http.ajax({
      method: 'delete',
      url: '/api/cs-pc-crm/teacher/delete',
      params,
    });
  },

  // 查询老师跟进的学员数_方季惟
  getTeacherFollowStudentCount(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-crm/teacher/getTeacherFollowStudentCount?teacherId=${id}`,
    });
  },

  // 查询离职待处理数量_方季惟
  getTeacherWaitThings(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-crm/teacher/getTeacherWaitThings?teacherId=${id}`,
    });
  },

  // 操作离职
  leaveOffice(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/leaveOffice',
      params,
    });
  },

  // 恢复入职
  backOffice(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/backOffice',
      params,
    });
  },

  // 编辑已注销账号的老师
  editUnRegisterTeacher(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/editUnRegisterTeacher',
      params,
    });
  },
  // 获取员工列表
  teacherPageList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/pageList',
      params,
    });
  },

  // 获取员工信息
  teacherGet(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-crm/teacher/get?id=${id}`,
    });
  },

  // 转让管理员
  transferManager(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/transferManager',
      params,
    });
  },

  // 获取所有员工
  allTeacherList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/getChooseTeacherList',
      params,
    });
  },

  // 创建角色
  createRole(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/role/create',
      params,
    });
  },

  // 删除角色
  deleteRole(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/role/delete',
      params,
    });
  },

  // 保存/修改权限
  savePermission(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/permission/save',
      params,
    });
  },

  // 获取角色权限树
  getPermission(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/permission/get',
      params,
    });
  },
  // 设置密码
  setPassword(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/setPassword',
      params,
    });
  },
  // 修改密码新接口
  passwordReset(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/password/reset',
      params,
    });
  },
  // 修改个人信息
  updateTeacherInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/teacher/update',
      params,
    });
  },
  // 获取部门信息
  // getOrgStructureList(params) {
  //   return app.http.ajax({
  //     method: 'post',
  //     url: '/api/cs-pc-crm/orgStructure/getOrgStructureList',
  //     params,
  //   });
  // },

  // 查询具体部门(获取负责人)
  getOrgStructure(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/getOrgStructure',
      params,
    });
  },
  // 获取部门人数
  getOrgTeacherCount(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/getOrgTeacherCount',
      params,
    });
  },
  // 增加部门
  addOrgStructure(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/add',
      params,
    });
  },

  // 编辑部门
  editOrgStructure(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/edit',
      params,
    });
  },

  // 删除部门
  deleteOrgStructure(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/delete',
      params,
    });
  },

  // 查询全部部门
  getAllOrgStructure(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/getAllOrgStructure',
      params,
    });
  },

  // 批量设置部门
  addOrgStructureId(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/orgStructure/addOrgStructureId',
      params,
    });
  },
  // 获取角色模板
  getRoleTemplate(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/roleTemplate/get',
      params,
    });
  },
  // 获取角色模板列表
  roleTemplateList() {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/roleTemplate/list',
    });
  },
  // 校验员工是否离职
  checkTeacherLeaveStatus(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/teacher/checkTeacherLeaveStatus',
      params,
    });
  },
  // 学员管理获取自定义字段-毛新武
  getStudentCustomField(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/customField/list',
      params,
    });
  },
  // 学员管理学员转无效-毛新武
  setStudentToInvalid(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/becomeInvalid',
      params,
    });
  },
  // 学员管理恢复为未收费-毛新武
  setStudentRestoreNotCharged(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/becomeNonCharge',
      params,
    });
  },
  // 获取学员电子钱包详情
  getWalletDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/student/getWalletDetail',
      params,
    });
  },
  // 电子钱包流水记录
  getWalletLog(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/getWalletLog',
      params,
    });
  },
  // 学员管理列表查询-毛新武
  getStudentExtendList(data) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/extendList',
      params: data,
    });
  },
  // 查询绑定二维码-毛新武
  getWechatInfoQrCode(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/student/getWechatInfo',
      params,
    });
  },
  // 新增学员-毛新武
  addStudentInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/add',
      params,
    });
  },
  // 编辑学员-毛新武
  editStudentInfo(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/update',
      params,
    });
  },
  // 查询学员-毛新武
  getStudentInfoDetail(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/student/detail',
      params,
    });
  },
  // 检查重复意向或学员-毛新武
  checkDuplicateClue(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/intention/clue/checkDuplicateClue',
      params,
    });
  },
  // 获取年级列表
  getGradeList() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/grade/list',
    });
  },
  // 获取学员列表_毛新武
  getStudentList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/student/list',
      params,
    });
  },
  // 获取学员详情_毛新武
  getStudentDetail(id) {
    return app.http.ajax({
      method: 'get',
      url: `/api/cs-pc-crm/student/detail?id=${id}`,
    });
  },
  // 开通收费管家消息发送
  // 会直接发送一个信息到产品的企业微信
  csCrmTeacherOpenPay() {
    return app.http.ajax({
      method: 'POST',
      url: '/api/cs-pc-crm/teacher/openPay',
    });
  },
  // 转课_刘鹏
  orderInfoTransferCourse(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/orderInfo/transferCourse',
      params,
    });
  },
  // 非同课价班级列表_刘鹏
  classByUnPriceItemId(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-edu/classInfo/classByUnPriceItemId/page',
      params,
    });
  },
  // 获取oss文件上传签名
  getOssRequest(file) {
    const fileType = getFileType(file);
    return async function abc() {
      const ret = await app.http.ajax({
        method: 'post',
        url: '/api/cs-pc-crm/common/getOssStsSign',
        params: {
          businessType: 'x3_other',
          fileName: file.name,
          fileSuffix: file.name.split('.').pop(),
          fileType,
          terminal: 0,
        },
      });
      const stsParams = ret.data;
      return stsParams;
    };
  },
  // 导入导学员信息新接口_钟军
  importStudent(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/import/student',
      params,
    });
  },
  // 导入线索_刘鹏
  importIntentionClue(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/import/intentionClue',
      params,
    });
  },
  // 查询自定义字段详情
  getByFieldCode(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/customField/getByFieldCode',
      params,
    });
  },
  // 开通电子钱包
  companyWalletOpen() {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/company/walletOpen',
    });
  },
  // 获取配置
  findConfigPersonaliseList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/configBusiness/findConfigPersonalise/list',
      params,
    });
  },
  // 保存配置
  saveConfigPersonaliseList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/configBusiness/saveConfigPersonalise',
      params,
    });
  },
  // 应用列表
  appStoreList(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/appStore/list',
      params,
    });
  },
  // 开通应用
  appStoreOpen(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/appStore/open',
      params,
    });
  },
  // 应用详情
  appStoreDetail(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/appStore/detail',
      params,
    });
  },
  // 获取基本信息
  businessLogin() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/teacher/businessLogin',
    });
  },
  // 获取系统授权码
  getGenerate(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/authorizeCode/getGenerate',
      params,
    });
  },
  // 生成系统授权码
  generateAuthCode(params) {
    return app.http.ajax({
      method: 'post',
      url: `/api/cs-pc-crm/authorizeCode/generate?often=${params.often}`,
      params,
    });
  },
  // 作废系统授权码
  destroyAuthCode(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/authorizeCode/doExpire',
      params,
    });
  },
  // 获取菜单
  myList() {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/menu/myList',
    });
  },
  // 获取角色列表
  roleList() {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/role/list',
      params: {
        page: {
          pageNum: 1,
          pageSize: 999,
        },
      },
    });
  },
  // 获取校区列表
  campusList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/campus/list',
      params,
    });
  },
  // 获取管理员权限
  getForAdmin(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/permission/getForAdmin',
      params,
    });
  },
  // 获取结构列表
  getCompanyList(params) {
    return app.http.ajax({
      method: 'get',
      url: '/api/cs-pc-crm/teacher/getCompanyList',
      params,
    });
  },
  // 查询所有线索_方jiwei
  clueAllPage(params) {
    return app.http.ajax({
      method: 'post',
      url: '/api/cs-pc-crm/intention/clue/allPage',
      params,
    });
  },
};
